export default /* istanbul ignore next */ ({ breakpoints, spacing: { unit } }) => ({
  narrow: {
    display: 'flex',
    paddingTop: unit * 2,
    width: `calc(50% - ${unit * 3.75}px)`,
    [`@media only screen and (max-width: ${breakpoints.values.md}px)`]: {
      width: '100%',
      margin: 0
    }
  },
  wide: {
    paddingTop: unit * 2,
    width: '100%'
  }
});
